import { loadAdminSettings, getAdminSignupEmail } from '../pages/admin/settings/settingsData';
import { getCachedGymId } from '../services/receptionist/gymContext';
import { getPlatformSettings } from './platformMoney';

function slugify(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'export';
}

/** Brand for gym admin / receptionist print & export (from admin gym settings). */
export function getGymExportBrand() {
  const gymId = getCachedGymId();
  const settings = loadAdminSettings(gymId);
  const gym = settings.gym || {};
  const email = getAdminSignupEmail(gymId) || '';

  return {
    name: gym.name?.trim() || 'My Gym',
    branch: gym.tagline?.trim() || '',
    address: gym.address?.trim() || '—',
    phone: gym.phone?.trim() || '—',
    email: email || '—',
    logo: settings.logoPreview || null,
  };
}

export function getGymExportSlug() {
  return slugify(getGymExportBrand().name) || 'gym';
}

/** Brand for owner panel print & export (from Owner → Settings). */
export function getOwnerExportBrand() {
  const settings = getPlatformSettings();
  const name = settings.softwareName?.trim() || 'Gym CRM';

  return {
    name,
    branch: 'Owner Panel',
    address: '—',
    phone: '—',
    email: '—',
  };
}

export function getOwnerExportSlug() {
  return slugify(getOwnerExportBrand().name) || 'platform';
}
